import packageInfo from '../package.json';

export const getVersionNumber = () => {
  const { version } = packageInfo;
  if (typeof window !== 'undefined') {
    window.reactVersion = packageInfo.version;
  }
};
